/* cf-delivery-charge-once.js - Click Fencing, 2026-09-02
 *
 * Pete: "there is an issue with the delivery. we add it to the order then shopify adds it also
 *        increasing the price quoted originally for the order and delivery."
 *        "so can we do remove the line item from the cart, let shopify do the charge. just make
 *        sure they dont get charged more than quoted in the calculator"
 *
 * ---------------------------------------------------------------------------------------
 * WHAT IS ACTUALLY TRUE, measured end to end on a real quote before writing a line of this.
 *
 * Flat Top 6000mm, delivery selected:
 *
 *     quote total   $679.11   (goods $580.11 + Perth Metro Delivery $99.00)
 *     cart total    $580.11   goods only - NO delivery line
 *
 * So the normal path ALREADY does what Pete is asking for. cf-real-line-items.js intercepts the
 * calculator's add-to-cart and rebuilds it from real products against
 *
 *     targetCents = grandTotal - taxCentsOf(q) - deliveryCentsOf(q)
 *
 * i.e. delivery is deliberately left out of the cart for Shopify to charge. Two things were
 * still wrong, and both are fixed here.
 *
 * ---------------------------------------------------------------------------------------
 * PROBLEM 1 - THE FALLBACK PATH STILL DOUBLE-CHARGED.
 *
 * When cf-real-line-items cannot resolve the quote to real variants it bails out:
 *
 *     function fallback(input,init,why){ ... raw("/cart/clear.js") ... return raw(input,init) }
 *
 * raw(input,init) replays the calculator's ORIGINAL payload, which is a single placeholder
 * variant whose quantity is the whole quote total in cents - delivery included. Shopify then
 * adds its own delivery on top, and the customer pays for delivery twice. That is the double
 * charge Pete saw; it is not the everyday path, which is why the cart above looks correct.
 *
 * This file wraps fetch and, when it sees that full-total placeholder line, subtracts the
 * delivery cents before it reaches the cart.
 *
 * IT ONLY ACTS ON A PROVEN MATCH. It does not guess which quote is being added. It only
 * rewrites the line when the posted cents EXACTLY equal the grandTotal of a saved quote that
 * actually contains a delivery line. If nothing matches to the cent, it changes nothing. That
 * also keeps it clear of cf-real-line-items' own "Balance of quoted total" line, whose quantity
 * is a small remainder and never equals a quote total.
 *
 * PROBLEM 2 - THE OPTION LABEL NAMED THE WRONG PRICE.
 *
 * The page template hardcodes
 *
 *     <label id="delivery-yes-label"> ... 🚚 Delivery (+$90) </label>
 *
 * but the line actually added to the quote is "Perth Metro Delivery $99.00", because
 * cf-quote-truth.js normalises it to METRO_DELIVERY = CF_TAXES_INCLUDED ? 99 : 90. The button
 * said $90 and the quote charged $99. Here the label is set from that SAME rule, so the two can
 * never drift apart again. Only the text node is touched - never the hidden radio inside the
 * label, which would break the control.
 *
 * ---------------------------------------------------------------------------------------
 * WHY $99 AND NOT $90, AND THE ONE THING THIS FILE CANNOT DO.
 *
 * The shop is tax-inclusive (shop.taxesIncluded = true, verified through the Admin API), so
 * every displayed price already contains GST. $99 is $90 ex-GST plus $9 GST - that is the
 * intended delivery price. Shopify's Local Delivery rate is set to $90, and because the shop is
 * tax-inclusive Shopify treats that $90 as ALREADY including GST, so it collects $90 where it
 * should collect $99.
 *
 * Shopify exposes no API for Local Delivery settings (there is locationLocalPickupEnable for
 * pickup, and nothing for delivery), so that one number had to be changed by hand in
 * Settings > Shipping and delivery > Local delivery > Canning Vale Warehouse.
 *
 * DONE: Pete set it to 99.00 on 2026-09-02. The quote and the checkout now agree to the cent,
 * and the $9 shortfall described in earlier versions of this comment no longer applies.
 *
 * No price, product or quote figure is changed by this file. It only stops the cart carrying a
 * delivery charge that Shopify is also going to make.
 */
(function () {
  'use strict';

  if (window.__cfDeliveryChargeOnce) return;
  window.__cfDeliveryChargeOnce = true;

  var PLACEHOLDER_VARIANT = 42909527670878;   /* the $0.01 line the calculator posts, qty = cents */
  var CALCS = ['ullc', 'blade', 'flattop', 'perfmesh'];

  /* Same rule as cf-quote-truth.js, so the label can never disagree with the charge. */
  function metroDelivery() {
    return window.CF_TAXES_INCLUDED === true ? 99 : 90;
  }

  function cents(n) { return Math.round((Number(n) || 0) * 100); }

  function allQuotes() {
    var out = [];
    CALCS.forEach(function (c) {
      try {
        var a = JSON.parse(localStorage.getItem(c + '_active_quote') || 'null');
        if (a && a.breakdown) out.push(a);
      } catch (e) {}
      try {
        var arr = JSON.parse(localStorage.getItem(c + '_quotes') || '[]') || [];
        if (Object.prototype.toString.call(arr) === '[object Array]') {
          arr.forEach(function (q) { if (q && q.breakdown) out.push(q); });
        }
      } catch (e) {}
    });
    return out;
  }

  function deliveryCents(q) {
    var t = 0;
    q.breakdown.forEach(function (b) {
      if (/^delivery$/i.test(String(b.category || '').trim())) t += cents(b.totalPrice);
    });
    return t;
  }

  /* ---------------------------------------------------------------- 1. honest label */
  function fixLabel() {
    try {
      var lab = document.getElementById('delivery-yes-label');
      if (!lab) return;
      var want = metroDelivery();
      [].forEach.call(lab.childNodes, function (n) {
        if (n.nodeType !== 3) return;            /* text nodes only - leave the radio alone */
        var s = n.textContent;
        if (!/\(\+\s*\$\s*[\d.,]+\s*\)/.test(s)) return;
        var next = s.replace(/\(\+\s*\$\s*[\d.,]+\s*\)/, '(+$' + want + ')');
        if (next !== s) n.textContent = next;
      });
    } catch (e) {}
  }

  /* ------------------------------------------- 3. every order says DELIVERY or PICKUP
   *
   * Pete, 2026-09-02: "the confusing part is the order still says free delivery pick up
   * canning vale. so there is no way for us to know if they paid the shopify delivery or
   * chose pick up... the entire order should come under delivery or pickup in the crm and
   * on the order forms sent to everyone."
   *
   * MEASURED on the real orders before writing this. Order #1015:
   *     note          "Perth Metro Delivery — $99.00 ... GRAND TOTAL: $2,120.61"
   *     shippingLine  "Canning Vale Warehouse", $0.00
   *     deliveryMethod PICK_UP
   * The order form said delivery; the order was a free pickup. Nothing on it reconciled the
   * two, so the office could not tell what the customer had actually paid for.
   *
   * WHERE THE TRUTH LIVES. The customer chooses twice - once in the calculator, and again at
   * Shopify's checkout, where both Local Delivery ($99) and free Canning Vale pickup are
   * offered. Only the second one is binding, and it is not known until after payment. So this
   * file does NOT claim to know what was paid. It writes down what was REQUESTED, in words, so
   * that the request and the shipping line can be compared at a glance:
   *
   *     Fulfilment Requested : DELIVERY - Perth Metro ($99, charged by Shopify at checkout)
   *                            PICKUP - Canning Vale Warehouse (free)
   *
   * and repeats it as a block in the order note, because the note is the order form that
   * actually gets sent around.
   *
   * The requested method is read straight out of the note being posted rather than guessed
   * from a saved quote - that note is built by quote-review.js from the very quote the
   * customer is checking out, so it cannot drift. "Free Pickup" is tested FIRST because the
   * pickup line is filed under a category called "Delivery" on some calculators (order #1013:
   * "Delivery — $0.00 • Free Pickup from our Canning Vale Warehouse").
   *
   * THE BINDING ANSWER IS STILL THE SHIPPING LINE on the order. A Shopify Flow tags each order
   * DELIVERY or PICKUP from that line; if the tag and this attribute ever disagree, the
   * customer changed their mind at checkout and the tag wins.
   */
  function requestedFulfilment(note) {
    var t = String(note || '');
    if (!t) return null;
    if (/free\s+pickup/i.test(t)) return 'pickup';
    if (/(perth\s+metro\s+delivery|flat\s+rate\s+delivery)/i.test(t)) return 'delivery';
    return null;
  }

  /* Pete, 22 Sep 2026: Perth metro delivery is FREE over $3,000, and Shopify's own local
     delivery zone applies that at checkout. This note used to promise "$99, charged by
     Shopify at checkout" on every delivery order, including the ones that are delivered
     free — so the order form contradicted both the quote and the shipping line.
     The quote the note is built from already says which it is: cf-free-delivery.js writes
     "Perth Metro Delivery — FREE (order over $3,000)" at $0.00 once the kit qualifies. */
  function deliveryIsFree(note) {
    var t = String(note || '');
    var line = t.match(/[^\n]*perth\s+metro\s+delivery[^\n]*/i);
    if (!line) return false;
    return /free/i.test(line[0]) || /\$\s*0(?:\.00)?\b/.test(line[0]);
  }

  function fulfilmentWords(kind, free) {
    if (kind !== 'delivery') return 'PICKUP - Canning Vale Warehouse (free)';
    return free
      ? 'DELIVERY - Perth Metro (FREE, order over $3,000)'
      : 'DELIVERY - Perth Metro ($' + metroDelivery() + ', charged by Shopify at checkout)';
  }

  function stampFulfilment(upd) {
    var kind = requestedFulfilment(upd && upd.note);
    if (!kind) return;                       /* cannot tell - say nothing rather than guess */
    var free = deliveryIsFree(upd && upd.note);

    upd.attributes = upd.attributes || {};
    upd.attributes['Fulfilment Requested'] = fulfilmentWords(kind, free);

    if (typeof upd.note === 'string' && upd.note.indexOf('FULFILMENT') === -1) {
      upd.note =
        'FULFILMENT REQUESTED: ' + fulfilmentWords(kind, free) + '\n' +
        '(What the customer asked for in the calculator. The binding answer is the shipping\n' +
        ' line on this order - if they differ, they changed it at checkout and the order wins.)\n' +
        '------------------------------\n\n' + upd.note;
    }
  }

  /* ------------------------------------------------- 2. delivery never rides in the cart */
  var origFetch = window.fetch;

  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      try {
        var url = String((input && input.url) || input || '');

        if (/\/cart\/update(\.js)?/.test(url) && init && init.body) {
          var upd = JSON.parse(String(init.body));
          if (upd) {
            stampFulfilment(upd);
            init = Object.assign({}, init, { body: JSON.stringify(upd) });
          }
        }

        if (/\/cart\/add(\.js)?/.test(url) && init && init.body) {
          var payload = JSON.parse(String(init.body));
          var it = (payload && payload.items && payload.items.length === 1) ? payload.items[0] : null;

          if (it && Number(it.id) === PLACEHOLDER_VARIANT && Number(it.quantity) > 1) {
            var posted = Number(it.quantity);
            var match = null;

            /* exact-to-the-cent match against a saved quote that really has delivery on it */
            allQuotes().forEach(function (q) {
              if (cents(q.grandTotal) === posted && deliveryCents(q) > 0) match = q;
            });

            if (match) {
              var d = deliveryCents(match);
              if (d > 0 && d < posted) {
                it.quantity = posted - d;
                it.properties = Object.assign({}, it.properties || {}, {
                  'Delivery': 'Charged by Shopify at checkout, not included in this line'
                });
                init = Object.assign({}, init, { body: JSON.stringify(payload) });
                try {
                  console.log('[cf-delivery-charge-once] took ' + d +
                              'c of delivery out of the quote-total line (' + posted +
                              'c -> ' + it.quantity + 'c)');
                } catch (e) {}
              }
            }
          }
        }
      } catch (e) {
        /* never let this stop a customer adding to cart */
        if (window.console && console.debug) console.debug('[cf-delivery-charge-once]', e);
      }
      return origFetch.call(this, input, init);
    };
  }

  function start() {
    fixLabel();
    /* the review step is re-rendered as the customer changes options */
    var n = 0;
    (function tick() {
      if (n++ > 60) return;
      fixLabel();
      setTimeout(tick, 500);
    })();
    try {
      if (window.MutationObserver) {
        var t = null;
        new MutationObserver(function () {
          if (t) clearTimeout(t);
          t = setTimeout(fixLabel, 80);
        }).observe(document.body, { childList: true, subtree: true });
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  try { console.log('[cf-delivery-charge-once] installed'); } catch (e) {}
})();
